export default __webpack_public_path__ + "static/18-5644849dbe8c1a598ab5c8af32be4dcb.jpg";